import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import {useTranslation} from "react-i18next";
import * as CPN from "antd";
import * as Func from "../../../../../helpers/functions";
import * as HMS from "../../../common/component/Index";
import Input from '../../../common/component/Input';
import Select, {Option} from '../../../common/component/Select';
import TextArea from '../../../common/component/TextArea';
import { DATE_TIME_FORMAT } from '../../../../../constants/Define';
import moment from 'moment';

export const EditComponent = (props) => {

    const {t} = useTranslation();
    const onRemove = () => {
        if (confirm(Func.formatValidation(t('validation.statusCode.code.7'), t(`item.banner.title`)))) { //eslint-disable-line
            props.onDeleteBanner({id: props.item.id})
        }
    };
    return (
        <Fragment>
            <Link to={`/banners/action/${props.item.id}`} className={`mr-2 colorPrimary`}>
                <CPN.Icon type="form" className="fs20"/>
            </Link>
            <CPN.Icon type="delete" className="fs20 colorPrimary" onClick={onRemove}/>
        </Fragment>
    )
};

export const UseVoucherComponent = (props) => {
    const {t} = useTranslation();
    return (
        <HMS.PopupModelComponent
            title={t(`item.checkVoucher.use`)}
            visible={props.showPopupUse}
            onClose={(i) => props.onClose(!props.showPopupUse)}
            confirmLoading={props.isSubmit}
            // onClose={(i) => this.setState({showPopupUse: !this.state.showPopupUse})}
            // onSubmit={() => this.onSubmit()}
            onSubmit={() => props.onSubmit()}
        >
            <form onSubmit={props.onSubmitUse}>
                {/*<form onSubmit={this.onSubmit}>*/}
                <HMS.FormWrapperInputComponent
                    // isRequired={true}
                    labelTitle={t(`item.checkVoucher.bill`)}
                >
                    <Input type="text"
                           autoComplete="off"
                           className="form-control" name="receiptCode" onChange={props.onChange}
                           value={Func.checkUndefine(props.data.receiptCode)}/>
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    // isRequired={true}
                    labelTitle={t(`item.checkVoucher.exportorder`)}
                >
                    <Input type="text"
                           autoComplete="off"
                           className="form-control" name="checkedSystem" onChange={props.onChange}
                           value={Func.checkUndefine(props.data.checkedSystem)}/>
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.checkVoucher.checkInDate`)}
                >
                    <HMS.DatePickerComponent
                        disabledDate={(current) => current && current < moment().add(-1, 'day')}
                        onChange={data => props.onChange({ ...data, value: data.fullValue })}
                        name={'checkInDate'}
                        format={DATE_TIME_FORMAT.SHORT_DATE_EXPORT}
                        value={props.data.checkInDate || null}
                        placeholder=""
                        style={{ width: '100%' }}
                    />
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.checkVoucher.checkOutDate`)}
                > 
                    <HMS.DatePickerComponent
                        disabledDate={(current) => current && current < moment().add(-1, 'day')}
                        onChange={data => props.onChange({ ...data, value: data.fullValue })}
                        name={'checkOutDate'}
                        format={DATE_TIME_FORMAT.SHORT_DATE_EXPORT}
                        value={props.data.checkOutDate || null}
                        placeholder=""
                        style={{ width: '100%' }}
                    />
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.checkVoucher.operaBookingCode`)}
                >
                    <Input type="text"
                           autoComplete="off"
                           className="form-control" name="operaBookingCode" onChange={props.onChange}
                           value={Func.checkUndefine(props.data.operaBookingCode)}/>
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.checkVoucher.propertyOfStay`)}
                >
                    <Select className="form-control" name="propertyOfStayId" onChange={props.onChange}
                            value={Func.checkUndefine(props.data.propertyOfStayId)} required>
                        <Option value="">Chọn cơ sở lưu trú</Option>
                        {
                            props.listProperty.length > 0 && props.listProperty.map((i, k) => {
                                return (
                                    <Option value={i.id} key={k}>{i.name}</Option>
                                )
                            })
                        }
                    </Select>
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    labelTitle={t(`item.checkVoucher.property`)}
                >
                    <Select className="form-control" name="propertyId" onChange={props.onChange}
                            value={Func.checkUndefine(props.data.propertyId)} required>
                        <Option value="">Chọn địa điểm sử dụng</Option>
                        {
                            props.propertyList.length > 0 && props.propertyList.map((i, k) => {
                                return (
                                    <Option value={i.id} key={k}>{i.name}</Option>
                                )
                            })
                        }
                    </Select>
                </HMS.FormWrapperInputComponent>
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.checkVoucher.note`)}
                >
                                        <TextArea
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.checkVoucher.note")).toLowerCase())}
                                            className="form-control" name="note" onChange={props.onChange}
                                            value={Func.checkUndefine(props.data.note)}/>
                </HMS.FormWrapperInputComponent>
            </form>
        </HMS.PopupModelComponent>
    )
};

export const LockVoucherComponent = (props) => {
    const {t} = useTranslation();
    return (
        <HMS.PopupModelComponent
            confirmLoading={props.isSubmit}
            title={t(`item.checkVoucher.lockvoucher`)}
            visible={props.showPopLock}
            onClose={(i) => props.onClose(!props.showPopLock)}
            // onClose={(i) => this.setState({showPopLock: !this.state.showPopLock})}
            onSubmit={() => props.onSubmit()}
            // onSubmit={() => this.onLock()}
        >
            <HMS.FormWrapperInputComponent
                labelTitle={t(`item.checkVoucher.reason`)}
            >
                                <TextArea
                                    required
                                    placeholder={t("item.checkVoucher.reason")}
                                    className="form-control"
                                    name="note"
                                    onChange={props.onChange}
                                    value={Func.checkUndefine(props.data.note)}/>
            </HMS.FormWrapperInputComponent>
            <CPN.Alert message={
                <Fragment>
                    {
                        (props.resultCheck ? props.data.serialNumber === props.resultCheck.checkCode : false) ? `Mã kiểm tra` : `Mã voucher`
                    }: <span style={{color: 'red'}}>{props.data.serialNumber}</span>
                </Fragment>
            } type="info"/>
        </HMS.PopupModelComponent>
    )
};
